/**
 * Mobile : buy-buttons fixé en bas tant que l’emplacement naturel (spacer) est
 * sous le bord bas du viewport ; au scroll, retour en flux normal.
 */
(function () {
  const MQ = '(max-width: 749px)';
  const initedRoots = new WeakSet();

  function initRoot(root) {
    if (initedRoots.has(root)) return;
    initedRoots.add(root);

    const block = root.querySelector('.buy-buttons-block');
    if (!block) return;

    let spacer = null;
    const mq = window.matchMedia(MQ);

    const ensureSpacer = () => {
      if (!spacer) {
        spacer = document.createElement('div');
        spacer.className = 'buy-buttons-block__mobile-dock-spacer';
        spacer.setAttribute('aria-hidden', 'true');
        spacer.style.display = 'none';
        block.parentNode?.insertBefore(spacer, block);
      }
      return spacer;
    };

    const removeSpacer = () => {
      spacer?.remove();
      spacer = null;
    };

    const setFixed = (fixed) => {
      if (fixed) {
        const h = block.offsetHeight;
        if (h <= 0) {
          block.classList.remove('buy-buttons-block--mobile-dock-fixed');
          removeSpacer();
          return;
        }
        const s = ensureSpacer();
        s.style.display = 'block';
        s.style.height = `${h}px`;
        block.classList.add('buy-buttons-block--mobile-dock-fixed');
      } else {
        block.classList.remove('buy-buttons-block--mobile-dock-fixed');
        if (spacer) {
          spacer.style.height = '';
          spacer.style.display = 'none';
        }
      }
    };

    const update = () => {
      if (!mq.matches) {
        block.classList.remove('buy-buttons-block--mobile-dock-fixed');
        removeSpacer();
        return;
      }

      const style = window.getComputedStyle(block);
      if (style.display === 'none' || style.visibility === 'hidden') {
        block.classList.remove('buy-buttons-block--mobile-dock-fixed');
        removeSpacer();
        return;
      }

      const dockFixed = block.classList.contains('buy-buttons-block--mobile-dock-fixed');
      const anchor = dockFixed && spacer ? spacer : block;
      const rect = anchor.getBoundingClientRect();
      const entirelyBelow = rect.top >= window.innerHeight;

      if (entirelyBelow) {
        setFixed(true);
      } else {
        setFixed(false);
      }
    };

    const onScroll = () => {
      window.requestAnimationFrame(update);
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    mq.addEventListener('change', onScroll);

    const ro = new ResizeObserver(() => onScroll());
    ro.observe(block);

    document.addEventListener('shopify:section:load', (e) => {
      if (e.target?.contains?.(root)) onScroll();
    });

    update();
  }

  function boot() {
    document.querySelectorAll('[data-product-buy-mobile-dock]').forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
